import moment from 'moment';

export class BlobSaver {
    public static saveFile(blob: Blob, filename: string ): void {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = filename;
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
    }

    public static openPdf(blob: Blob, filename: string): void {
        const file = new File([blob], filename, { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(file);
        const openedWindow = window.open(objectUrl, '_blank');

        if (!openedWindow) {
            this.saveFile(blob, filename);
            URL.revokeObjectURL(objectUrl);
            return;
        }

        const revoke = () => URL.revokeObjectURL(objectUrl);
        window.addEventListener('beforeunload', revoke, { once: true });
    }
}